////////////////////////////////////////////////////////////////////////////////
// Landing Page
////////////////////////////////////////////////////////////////////////////////

class Landing extends Pages {

	constructor(entry) {
		super(entry)
	}

	// ===========================================================================
	// Load In
	// ===========================================================================

	in (content, done) {

		$('site-wrapper > *:last-child').before(content)

		document.body.classList.add('landing')

		let header        = $('header'),
			  h1            = header.find('h1'),
			  lead          = header.find('.lead'),
			  introduction  = header.find('.introduction'),
			  callToActions = header.find('call-to-actions'),
			  contentBlocks = $('content-blocks'),
				children      = $('.links-container ul li')

		if ( children.length ) {
			document.body.classList.add('overview')
			TweenMax.set(children, {y:20, opacity:0})
			TweenMax.staggerTo(children, 0.4, {y:0, opacity:1, ease:Power2.easeOut, delay:1}, 0.2)
		}	

		if ( contentBlocks.length ) {
			TweenMax.from(contentBlocks, 1, { opacity:0, ease:Power2.easeOut, delay:(firstvisit ? 1.8 : 0.8) })
		}

		if ( header.length ) {
			TweenMax.from(lead, 1, { opacity:0, ease:Power2.easeOut, delay:(firstvisit ? 1.5 : 0.5) })
			TweenMax.from(introduction, 1, { opacity:0, ease:Power2.easeOut, delay:(firstvisit ? 1.8 : 0.8) })
			TweenMax.from(callToActions, 1, { opacity:0, ease:Power2.easeOut, delay:(firstvisit ? 2.2 : 1.2) })
		}

		if ( h1.length ) {
			let split = new SplitText(h1, { type:"words, lines"} )
			TweenMax.staggerFrom(split.words, 0.8, {y:100, ease:Power2.easeOut, delay:0.5}, 0.05, () => {
				split.revert()
				if (typeof done == 'function') { done() }
			})
		} else {
			if (typeof done == 'function') { done() }
		}

		try {
			if ( (this.entry.slug == 'home' || this.entry.slug == 'rsa' || this.entry.slug == 'uae' ) && $('slide-image.video').length ) {
					// Object.values(slideshow.videos)[0].h.parentNode.parentNode.classList.remove('hide')
			}
		} catch(err) {
			console.log(err)
		}

		let slogan = $('navigation-bar .slogan');
		let position = slogan.offset().top + slogan.outerHeight(true);
		// header.css('padding-top', position + 'px');
	}

	// ===========================================================================
	// Load Out
	// ===========================================================================

	out (content, done) {

		let header        = $('header'),
			  h1            = header.find('h1'),
			  lead          = header.find('.lead'),
			  introduction  = header.find('.introduction'),
				contentBlocks = $('content-blocks'),
			  callToActions = header.find('call-to-actions'),
				children      = $('.links-container ul li')

		if ( children.length ) {
			TweenMax.staggerTo(children, 0.6, {y:20, opacity:0, ease:Power2.easeOut}, 0.03)
		}
		
		if ( contentBlocks.length ) {
			TweenMax.staggerTo(contentBlocks, 0.6, {y:20, opacity:0, ease:Power2.easeOut}, 0.03)
		}

		if ( header.length ) {
			TweenMax.to(lead, 1, {opacity:0, ease:Power2.easeOut, delay:0})
			TweenMax.to(introduction, 1, {opacity:0, ease:Power2.easeOut, delay:0.3})
			TweenMax.to(callToActions, 1, {opacity:0, ease:Power2.easeOut, delay:0.6})
		}

		if ( h1.length ) {
			let split = new SplitText(h1, { type:"words, lines"} );
			TweenMax.staggerTo(split.words, 0.6, {x:-16, opacity:0, ease:Power2.easeOut, delay:0.2}, 0.03, () => {
				if (typeof done == 'function') { done() }
			})
		} else {
			if (typeof done == 'function') { done() }
		}

	}

}
